import { render, staticRenderFns } from "./workTemplate.vue?vue&type=template&id=387cdea6&scoped=true&"
import script from "./workTemplate.vue?vue&type=script&lang=ts&"
export * from "./workTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./workTemplate.vue?vue&type=style&index=0&id=387cdea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cdea6",
  null
  
)

export default component.exports